import { h, render } from 'preact';
import Recommendations from './product-recommendations';

export default (element, data) => {
  const init = () => {
    render(<Recommendations {...data} />, element);
  };

  init();
};
